﻿import alasql from "alasql";

export const executarAlaSql = async (query: string, fontesDados?: any, vistra?: any) => {
    if(!query) return; 
    
    let retorno = await registrarFontesDadosAlasql(query, fontesDados);
    
    if(!retorno){
        try {
            return alasql(query)
        } catch (error: any) {
            vistra.showMessage(error.message, "error")
        }
    } else
        vistra.showMessage(retorno, "error")
}

export const obterNomesTabelas = async (query: string) => {
    const regex = /(?:FROM|JOIN)\s+(\w+)/gi;
    const tables: string[] = [];
    let match;
    while ((match = regex.exec(query)) !== null) {
        tables.push(match[1]);
    }
    return tables;
}

export const obterCamposTabela = (resultadoConsulta: any, fonteDadosSelecionada: any) => {
    if (resultadoConsulta && resultadoConsulta.length > 0) {
        const primeiroRegistro = resultadoConsulta[0];
        const nomesCampos = Object.keys(primeiroRegistro);

        //persiste os dados no objeto de fonte de dados selecionado
        fonteDadosSelecionada.dados = resultadoConsulta;
        const camposAdicionados = fonteDadosSelecionada.campos.filter(c => !nomesCampos.includes(c.campo) && c.campoFuncao);
        
        const objetoComCamposModificados = nomesCampos.map(nomeCampo => {
            let campoSelecionado = fonteDadosSelecionada.campos.filter(c => c.campo == nomeCampo)[0];
            
            return {
                campo: nomeCampo,
                titulo: !campoSelecionado ? nomeCampo : campoSelecionado.titulo,
                tipo: getTipoCampo(resultadoConsulta, nomeCampo),
                campoFuncao: !campoSelecionado ? false : campoSelecionado.campoFuncao,
                idFonteDados: fonteDadosSelecionada.id,
                funcao: !campoSelecionado ? "" : campoSelecionado.funcao,
                formatacao: !campoSelecionado ? {} : campoSelecionado.formatacao
            };
        });
        
        return objetoComCamposModificados.concat(camposAdicionados);
        
    } else {
        fonteDadosSelecionada.dados = [];
        return [];
    }
};

const getTipoCampo = (dados, nomeCampo) => {
    for (let registro of dados) {
        const valor = registro[nomeCampo];
        if (valor !== null && valor !== undefined) {
            if (typeof valor === 'number') {
                return Number.isInteger(valor) ? 'INTEGER' : 'DOUBLE';
            } else if (typeof valor === 'string') {
                if (!isNaN(Date.parse(valor))) {
                    const re = /\d\d\d\d-\d\d-\d\d/
                    if (valor instanceof Date || re.exec(valor) != null)
                        return 'DATE'
                    return 'DATETIME';
                }
                return 'VARYING';
            } else if (typeof valor === 'boolean') {
                return 'BOOLEAN';
            } else if (!isNaN(Date.parse(valor))) {
                const re = /\d\d\d\d-\d\d-\d\d/
                if (valor instanceof Date || re.exec(valor) != null)
                    return 'DATE'
                return 'DATETIME';
            }
        }
    }
    return 'VARYING';
};

const procuraTabelasFontesDados = async (nomeTabela: string, fontesDados?: any) => {
    for (let i = 0; i < fontesDados.length; i++) {
        if (fontesDados[i].aliasSqlQuery && fontesDados[i].aliasSqlQuery === nomeTabela) {
            return fontesDados[i].dados;
        }
    }
};

const registrarFontesDadosAlasql = async (query: string, fontesDados?: any) => {

    const nomesTabelas = await obterNomesTabelas(query);
    for (let tabela of nomesTabelas) {
        const dadosTabela = await procuraTabelasFontesDados(tabela, fontesDados);
      
        if (dadosTabela) {
            alasql.tables[tabela] = {data: dadosTabela};
        } else {
            return `Tabela ${tabela} não encontrada nas fontes de dados.`;
        }
    }
};